import { gql } from "graphql-request";

export const GET_CATEGORIES = gql`
  query GetCategories(
    $filter: String!
    $sort: String!
    $pageNo: Int!
    $pageSize: Int!
  ) {
    getcategorys(
      input: {
        filter: $filter
        sort: $sort
        pageNo: $pageNo
        pageSize: $pageSize
      }
    ) {
      totalCount
      totalPages
      hasNextPage
      hasPreviousPage
      items {
        ItemId
        CreatedDate
        CreatedBy
        LastUpdatedDate
        LastUpdatedBy
        Language
        OrganizationIds
        Tags
        DeletedDate
        categoryName
      }
    }
  }
`;

export const INSERT_CATEGORY = gql`
  mutation InsertCategory(
    $categoryName: String!
    $tags: [String]
    $organizationIds: [String]
  ) {
    insertcategory(
      input: {
        categoryName: $categoryName
        Tags: $tags
        OrganizationIds: $organizationIds
      }
    ) {
      acknowledged
      totalImpactedData
      itemId
    }
  }
`;

export const UPDATE_CATEGORY = gql`
  mutation UpdateCategory($filter: String!, $categoryName: String!) {
    updatecategory(filter: $filter, input: { categoryName: $categoryName }) {
      acknowledged
      totalImpactedData
      itemId
    }
  }
`;

export const DELETE_CATEGORY = gql`
  mutation DeleteCategory($filter: String!) {
    deletecategory(filter: $filter, input: { isHardDelete: true }) {
      acknowledged
      totalImpactedData
      itemId
    }
  }
`;
